import { takeEvery, fork, put, all, call } from "redux-saga/effects";

//Account job Management
import { EXCHANGE_CODE } from "./actionTypes";
import { exhangeCodeSuccess, exhangeCodeFailed } from "./actions";

import { getAllCounties } from "../../../../helpers/fakebackend_helper";

//restapi end point
import * as constClass from "../../../../common/constant/constantURL";

function* exchangeCodeHandler({ payload: { type, code } }) {
  try {
    var responsJSON = yield call(
      getAllCounties,
      constClass.REST_API_CALL_BACK + type + "?code=" + code,
    );
    yield put(exhangeCodeSuccess(responsJSON));
  } catch (error) {
    yield put(exhangeCodeFailed(error));
  }
}

export function* functionList() {
  yield takeEvery(EXCHANGE_CODE, exchangeCodeHandler);
}

function* oauthCallbackSaga() {
  yield all([fork(functionList)]);
}

export default oauthCallbackSaga;
